import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { stopBottomBounce } from "@/lib/noBounce";

stopBottomBounce();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
